import React, { useState } from 'react';
import './VideoFeedbackButtons.css';

interface VideoFeedbackButtonsProps {
    onLike: () => void;
    onDislike: () => void;
    disabled?: boolean;
}

export const VideoFeedbackButtons: React.FC<VideoFeedbackButtonsProps> = ({
    onLike,
    onDislike,
    disabled = false
}) => {
    const [selected, setSelected] = useState<'like' | 'dislike' | null>(null);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleLike = () => {
        if (disabled || isAnimating) return;
        
        setIsAnimating(true);
        setSelected('like');
        
        setTimeout(() => {
            onLike();
            setIsAnimating(false);
        }, 300);
    };

    const handleDislike = () => {
        if (disabled || isAnimating) return;
        
        setIsAnimating(true);
        setSelected('dislike');
        
        setTimeout(() => {
            onDislike();
            setIsAnimating(false);
        }, 300);
    };

    return (
        <div className="video-feedback-buttons">
            <button
                className={`feedback-btn feedback-btn--like ${selected === 'like' ? 'selected' : ''}`}
                onClick={handleLike}
                disabled={disabled || isAnimating}
                aria-label="Beğendim"
            >
                <span className="feedback-btn__icon">👍</span>
                <span className="feedback-btn__text">Beğendim</span>
            </button>

            <button
                className={`feedback-btn feedback-btn--dislike ${selected === 'dislike' ? 'selected' : ''}`}
                onClick={handleDislike}
                disabled={disabled || isAnimating}
                aria-label="Beğenmedim"
            >
                <span className="feedback-btn__icon">👎</span>
                <span className="feedback-btn__text">Beğenmedim</span>
            </button>
        </div>
    );
};

export default VideoFeedbackButtons;
